




























































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  alertStore,
  bibliographySearchStore,
  modalBibliographyDetailStore,
  modalBibliographySearchResultContentStore,
  modalBibliographySearchStore,
  modalErrorStore,
  modalJobListStore
} from '@/utils/store-accessor'
import { BibliographySearchResultsContentTable } from '@/components/organisms/BibliographySearchResultsContentTable'
import {
  AlertMessage,
  BibliographySearchResultContentItem,
  ErrorMessage,
  jobApi
} from '@/api'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { BibliographySearchType, SortOrder } from '@/types'
import { FirstTransitionToBibliographyDetail } from '@/store/BibliographyDetailStore'
import { ColItem } from '@/components/molecules/DataTable'
import { orderBy } from 'lodash'

@Component({
  components: {
    ModalFooter,
    BibliographySearchResultsContentTable
  }
})
export default class ModalBibliographySearchResultContent extends ModalComponentBaseVue {
  tableBodyHeight: number = 0

  scrollTop: number = 0

  activeRowIndex: number = 0

  sortName: string = ''

  sortOrder: SortOrder = ''

  get isBibliographySearchTypeAuthority(): boolean {
    return (
      modalBibliographySearchStore.bibliographySearchType ===
      BibliographySearchType.Authority
    )
  }

  get isOpen() {
    return modalBibliographySearchResultContentStore.isOpen
  }

  get searchKeyWord() {
    if (
      modalBibliographySearchStore.bibliographySearchType ===
      BibliographySearchType.Authority
    ) {
      return modalBibliographySearchStore.inputAuthoritySearchItem.contentAuthor
        .input
    }

    const item = modalBibliographySearchStore.inputContentSearchItem
    const words = []
    if (item.title.input !== '') {
      words.push(item.title.input)
    }

    if (item.contentTitle.input !== '') {
      words.push(item.contentTitle.input)
    }

    if (item.contentAuthor.input !== '') {
      words.push(item.contentAuthor.input)
    }

    if (item.holdingBranchCodes.input !== '') {
      words.push(
        ...item.holdingBranchCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          )
      )
    }

    return words.join(' ')
  }

  get displayItems() {
    return modalBibliographySearchStore.contentItems
  }

  get existsDisplayItems(): boolean {
    return this.displayItems.length > 0
  }

  @Watch('isOpen')
  initialize() {
    if (this.isOpen) {
      window.addEventListener('resize', this.calculateTableHeight)
      this.$nextTick(() => {
        this.calculateTableHeight()
        setTimeout(() => {
          this.scrollTop = modalBibliographySearchStore.scrollTopValue
          this.activeRowIndex = modalBibliographySearchStore.activeRowIndex
          this.setScroll()
        })
      })
      return
    }

    modalBibliographySearchStore.setScrollTopValue(this.scrollTop)
    modalBibliographySearchStore.setActiveRowIndex(this.activeRowIndex)
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  close() {
    modalBibliographySearchResultContentStore.close()
  }

  onClickPrint(): void {
    const element = document.getElementById(
      'modal-bibliography-search-result-content'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onClickTitle(item: BibliographySearchResultContentItem) {
    modalBibliographyDetailStore.setFirstTransitionSource(
      FirstTransitionToBibliographyDetail.SearchResult
    )
    this.setActiveRow(
      this.displayItems.findIndex(value => value._index === item._index)
    )
    modalBibliographySearchResultContentStore.selectContent({
      prefix: item.prefix,
      bibliographyRealId: item.bibliographyId,
      bibliographyContentId: item.bibliographyContentId
    })
  }

  onClickBack() {
    modalBibliographySearchResultContentStore.back()
  }

  onClickBackResult(): void {
    modalBibliographySearchResultContentStore.backResult()
  }

  setScrollTop(value: number): void {
    this.scrollTop = value
  }

  setScroll(): void {
    setTimeout(() => {
      const tableScroller: HTMLCollection | null = document.getElementsByClassName(
        'search-result-content-scroller'
      ) as HTMLCollectionOf<HTMLElement>

      tableScroller[0].scrollTo(0, this.scrollTop)
    })
  }

  setActiveRow(index: number): void {
    this.activeRowIndex = index
  }

  onSort(sortColItem: ColItem | undefined): void {
    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''

    if (this.displayItems.length === 0) {
      return
    }

    const tempUniqueKey = this.displayItems[this.activeRowIndex]?._index ?? -1

    bibliographySearchStore.setContentItems(
      orderBy<BibliographySearchResultContentItem>(
        this.displayItems,
        (item: BibliographySearchResultContentItem) =>
          item[this.sortName as keyof BibliographySearchResultContentItem],
        this.sortOrder as 'asc' | 'desc'[]
      )
    )

    this.setActiveRow(
      this.displayItems.findIndex(item => item._index === tempUniqueKey)
    )
  }

  async createBibliographySearchContentList(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const jobId = await jobApi.createBibliographySearchContentList({
        ids: this.displayItems.map(item => item.bibliographyContentId)
      })

      await modalJobListStore.newJobId(jobId)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
